import { mapGetters } from 'vuex'
import {
  limitObject
  // getByteLen
} from '@/utils'

export default {
  props: {
    info: Object,
  },

  data: () => ({
    loading: false,
    currPage: '', // 在Base/More/Seo中添加
  }),

  computed: {
    ...mapGetters(['user_info']),

    // 当前vip等级:   1 导购版 2用户中心版 3返利代理版 4尊享版
    vip() {
      return this.user_info.vip
    },
  },

  watch: {
    info: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          let form = limitObject(this.info, Object.keys(this.form), true) // 过滤不需要的字段
          this.form = form  // 填充表单
        }
      },
    },
  },

  methods: {

    // 提交转换
    submitBeforeTransform(obj) {
      return obj
    },

    async onSubmit() {

      // if (!this.verify()) {
      //   return this.$message.error('请输入有效的网站名称')
      // }

      this.loading = true


      let form = { ...this.form }
      form = this.apiPermission(form)
      // form = emtry2null(form)
      // 如果选择没有域名则删除备案项
      if (this.radio == '2') {
        delete form.icpno
      }
      const formFormat = this.submitBeforeTransform({...form})
      const data = await this.$store.dispatch('SetCmsInfo', formFormat)

      if (data.error_code != 0) {
        this.$message.error(data.error_message)
      }
      else {
        this.$emit('changed')
        this.$message.success('修改成功')
        const { ssl, domain } = this.$store.getters.cms_info

        // 判断domain或ssl已变更，并且选择了自有域名
        if (
          (domain !== form.domain || ssl !== form.ssl) && 
          (this.domainTypeModel === 3)
        ) {
          this.$msgbox('请确认您的域名是否已解析，cms将在域名解析后2小时内生效。', '提示')
        }
      }

      this.loading = false
    },

    verify() {
      // const titleLen = getByteLen(this.form.title) * 2
      // if (titleLen < 2 || titleLen > 10) {
      //   this.$message.error('请输入网站名称2至10个字符，1个中文计为1个字符')
      //   return false
      // }

      // return true

      const len = this.form.title.length
      console.log(len)

      return len >= 2 && len <= 10
    },

    apiPermission(data) {
      if (this.vip < 2) {
        Array(
          'cms_tksy'
        ).forEach((key) => {
          delete data[key]
        })
      }
      return data
    },
  },

}